module.exports = __webpack_public_path__ + "img/H12.279e7dd9.jpg";